import { useDispatch } from "react-redux";
import { push } from "connected-react-router"
import styled from 'styled-components'
import { Layout } from '../components'
// Mui
import Button from "@material-ui/core/Button"
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
// import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
// import TableSortLabel from '@material-ui/core/TableSortLabel';
import DraftsIcon from '@material-ui/icons/Drafts';
import MailIcon from '@material-ui/icons/Mail';
import ReplyIcon from '@material-ui/icons/Reply';
import { useEffect, useState } from 'react';
import { db } from '../firebase';

const dateTimeToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) + ' ' + 
        ('00' + date.getHours()).slice(-2) + ':' + 
        ('00' + date.getMinutes()).slice(-2) + ':' + 
        ('00' + date.getSeconds()).slice(-2)
}

const ContactManager = () => {

    const dispatch = useDispatch()
    const [contacts, setContacts] = useState([])
    const [showNotYetOpened, setShowNotYetOpened] = useState(false)
    const [showNotYetReplied, setShowNotYetReplied] = useState(false)


    const FilteredTableRow = props => {
        const contact = props.contact
        return (
            <TableRow
                style={{cursor: 'pointer'}}
                key={contact.id} hover role="checkbox" tabIndex={-1} selected={false}
                onClick={() => dispatch(push('/admin/contact/dp/' + contact.id))}
            >
                <TableCell align="center">
                    {contact.isOpen ? <DraftsIcon color={'disabled'}/> : <MailIcon color={'primary'} />}
                </TableCell>
                <TableCell align="center">
                    {contact.isReply ? <ReplyIcon color={'disabled'}/> : ""}
                </TableCell>
                <TableCell align="left">{contact.name}</TableCell>
                <TableCell align="left">{contact.matter}</TableCell>
                <TableCell align="left">{contact.inquery.substr(0,20) + "…"}</TableCell>
                <TableCell align="right">{contact.created_at ? dateTimeToString(contact.created_at.toDate()) : ""}</TableCell>
            </TableRow>
        )
    }

    // 問合せ一覧情報を取得
    useEffect(()=>{
        db.collection('contacts').orderBy('created_at','desc').get()
          .then(snapshots=>{
                const tempContactList = []
                snapshots.forEach(snapshot => {
                    tempContactList.push(snapshot.data())
                })
                setContacts(tempContactList)
          })
    },[])

    return (
        <Layout>
            <div className='spacer-50' />
            <h1 style={{textAlign: 'center'}}>お問い合わせ管理</h1>
            <div className='spacer-50' />

            <div style={{textAlign: 'center'}}>
                <Button onClick={()=>setShowNotYetOpened(!showNotYetOpened)}>
                    {showNotYetOpened ? '開封済も表示' : '未開封のみ表示'}
                </Button>
                <Button onClick={()=>setShowNotYetReplied(!showNotYetReplied)}>
                    {showNotYetReplied ? '返信済も表示' : '未返信のみ表示'}
                </Button>
            </div>
            <div className='spacer-50' />

            <Wrapper>
                
                <TableContainer>
                    <Table
                        aria-labelledby="tableTitle"
                        size={'medium'}
                        aria-label="enhanced table"
                    >
                        <TableHead>
                            <TableRow>  
                                <TableCell key={1} align={'center'} padding={'default'} sortDirection={false} >
                                    開封
                                </TableCell>
                                <TableCell key={2} align={'center'} padding={'default'} sortDirection={false} >
                                    返信
                                </TableCell>
                                <TableCell key={3} align={'center'} padding={'default'} sortDirection={false} >
                                    お名前
                                </TableCell>
                                <TableCell key={4} align={'center'} padding={'default'} sortDirection={false} >
                                    問合せ種別
                                </TableCell>
                                <TableCell key={5} align={'center'} padding={'default'} sortDirection={false} >
                                    問合せ内容
                                </TableCell>
                                <TableCell key={6} align={'center'} padding={'default'} sortDirection={false} >
                                    問合せ日時
                                    {/* <TableSortLabel active={true} direction={'asc'} onClick={()=>console.log('sort!')}>
                                        問合せ日時
                                    </TableSortLabel> */}
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {contacts.length > 0 && contacts.map((contact,index)=>{
                                if (showNotYetOpened && showNotYetReplied) {
                                    return !contact.isOpen && !contact.isReply ? <FilteredTableRow key={index} contact={contact} /> : false
                                } else if (showNotYetOpened) {
                                    return !contact.isOpen ? <FilteredTableRow key={index} contact={contact} /> : false
                                } else if (showNotYetReplied) {
                                    return !contact.isReply ? <FilteredTableRow key={index} contact={contact} /> : false
                                } else {
                                    return <FilteredTableRow key={index} contact={contact} />
                                }
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Wrapper>

            <div className='spacer-100' />
        </Layout>
    )
}
export default ContactManager

const Wrapper = styled.div`
    width: 960px;
    margin: 0 auto;
`